//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    question: String,
    answer: String,
    buttons: {
      type: Boolean,
      default: false
    }
  }
}

